import {GetContratosPesquisa} from "@localization/siteMap/endpoints/_ContratosEndpoints.js";
import type {IContrato} from "@models/contratos/contrato.js";
import {CreateContratoPage} from "@components/contratos/pages/CreateContratoPage.js";
import React from "react";
import {DefaultPesquisaProps, PesquisaAutocomplete} from "@shared/specialComponents/PesquisaComponent.tsx";

interface ContratoPesquisaProps extends DefaultPesquisaProps<IContrato> {
}

export const ContratoPesquisa: React.FC<ContratoPesquisaProps> = ({
                                                                      onSelect,
                                                                      clearOnSelect,
                                                                      overrides,
                                                                  }) => {
    const handleItemSelected = (item?: IContrato) => {
        if (onSelect) {
            onSelect(item);

        }
    };

    const formatar = (contrato: IContrato) => `${contrato.id} - ${contrato.nome ?? ''}`;

    return (
        <PesquisaAutocomplete<IContrato> searchFn={GetContratosPesquisa}
                                         itemToString={formatar}
                                         onItemSelected={handleItemSelected} // Pass the selection handler
                                         label={overrides?.label ?? "Contrato"}
                                         placeholder="Selecione um contrato"
                                         clearOnSelect={clearOnSelect}
                                         infoPopupTitle="Informações do contrato"
                                         renderInfoContentWithoutItem
                                         renderInfoContent={() => <CreateContratoPage/>}
                                         textFieldProps={{required: overrides?.required ?? false}}/>
        /*<Paper elevation={3}>
            <Autocomplete value={searchFilter}
                          onChange={handleChange}
                          loading={loading}
                          freeSolo
                          onInputChange={(_e, v) => {
                              setSearchFilter(v)
                          }}

                          renderInput={
                              (params) =>
                                  <Box sx={{display: 'flex', alignItems: 'center'}}>
                                      <TextField {...params} type={'text'} label={'Contrato'} variant={'filled'}
                                                 placeholder={'Selecione um contrato'}
                                      />{

                                      <IconButton onClick={() => {
                                          openCriarContrato()
                                      }} size={'large'} disabled={false}>
                                          <Info/>
                                      </IconButton>}
                                  </Box>}
                          renderOption={(props, option) => (
                              <li {...props} key={option}>
                                  {option}
                              </li>
                          )}
                          options={contratos.map(x => `${x.id} - ${x.identificacao ?? ''} - ${x.fornecedor?.nome}`)}/>
        </Paper>*/
    )
}